<template>
    <div class="ourSpaceBG" v-loading="loadingPageTag">

        <el-row>
            <el-col :span="16" :offset="4">
                <el-backtop target=".ourSpaceBG" style="background-color:#ffefef;width:50px;height:50px;"></el-backtop>

                <div class="storyCard storyHidden">
                    <el-row :gutter="20">
                        <el-col :span="16">

                            <el-card class="line1">
                                <el-row>
                                    <el-col class="storyText">
                                        <span class="storyTitle">
                                            照片墙
                                        </span>
                                    </el-col>
                                </el-row>
                                <el-divider content-position="left">
                                    <i class="el-icon-picture storyDate"></i>
                                </el-divider>
                                <el-carousel trigger="click" :interval="4000" type="card" height="200px">
                                    <el-carousel-item v-for="item in photoWall">
                                        <el-image :src="item" fit="cover" style="height:100%;"
                                            :preview-src-list="photoWall">
                                        </el-image>
                                    </el-carousel-item>
                                </el-carousel>
                            </el-card>

                        </el-col>
                        <el-col :span="8">

                            <el-card class="line1">

                                <el-row>
                                    <el-col class="storyText">
                                        <span class="storyTitle">
                                            小计划
                                        </span>
                                    </el-col>
                                </el-row>
                                <el-divider content-position="left">
                                    <i class="el-icon-s-order storyDate"></i>
                                </el-divider>
                                <el-row :gutter="10">
                                    <el-col :span="18">
                                        <el-input v-model="littlePlan" placeholder="写下你的小计划吧！" size="medium"
                                            maxlength="50" show-word-limit>

                                        </el-input>
                                    </el-col>

                                    <el-col :span="6">
                                        <el-tooltip content="点击添加" placement="top" effect="light">
                                            <el-button circle icon="el-icon-edit" type="primary" size="medium"
                                                @click="submitPlan()"></el-button>
                                        </el-tooltip>

                                    </el-col>
                                </el-row>
                                <el-row style="height:190px;overflow: scroll;margin-top:10px;">
                                    <el-col v-if="this.plans.length === 0">
                                        <el-empty description="还没有计划，快添加吧！" :image-size="70"></el-empty>
                                    </el-col>
                                    <el-col style="margin-top:10px;" :span="24" v-for="item in plans">

                                        <el-card shadow="hover" style="position: relative;">

                                            <el-tooltip content="点击关闭这个小计划" placement="bottom" effect="light">
                                                <el-button circle size="mini" type="info" class="planBtn"
                                                    @click="closePlan(item)">
                                                </el-button>
                                            </el-tooltip>

                                            <el-row>
                                                <el-col :span="24" style="text-align:left;">
                                                    <span class="writtenByZxt" v-if="item.plan_person === '张小兔'">
                                                        张小兔
                                                    </span>
                                                    <span class="writtenByYxy" v-if="item.plan_person === '杨小鱼'">
                                                        杨小鱼
                                                    </span>
                                                </el-col>
                                            </el-row>


                                            <el-row>
                                                <el-col :span="24" style="text-align:left;">
                                                    <span class="planText">
                                                        {{ item.plan_content }}
                                                    </span>
                                                </el-col>
                                            </el-row>


                                            <el-row>
                                                <el-col :span="24" style="text-align:left;">

                                                    <span class="planExtension">
                                                        {{ $moment(item.plan_date).format('YYYY-MM-DD') }}&nbsp;&nbsp;
                                                    </span>

                                                    <span class="planExtension planFinished"
                                                        v-if="item.plan_finish === 'finished'"
                                                        @click="toFinishingPlan(item)">
                                                        已完成
                                                    </span>
                                                    <span class="planExtension planFinishing"
                                                        v-if="item.plan_finish === 'no'" @click="toFinishedPlan(item)">
                                                        未完成
                                                    </span>

                                                </el-col>
                                            </el-row>
                                        </el-card>


                                    </el-col>
                                </el-row>
                            </el-card>

                        </el-col>
                    </el-row>
                </div>


                <div class="storyCard storyHidden">
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-card class="storyCard storyHidden line2">
                                <el-row>
                                    <el-col class="storyText">
                                        <span class="storyTitle">
                                            倒计时
                                        </span>
                                    </el-col>
                                </el-row>
                                <el-divider content-position="left">
                                    <i class="el-icon-alarm-clock storyDate"></i>
                                </el-divider>
                                <el-row :gutter="10">

                                    <el-col :span="18">
                                        <el-date-picker v-model="countDownTime" type="datetime" placeholder="选择日期时间"
                                            size="default" style="width:100%">
                                        </el-date-picker>
                                    </el-col>

                                    <el-col :span="3">
                                        <el-tooltip content="事件是否紧急" placement="top" effect="light">
                                            <el-switch v-model="emergencyCountDown" active-color="#ff6363"
                                                inactive-color="#909399" style="position:relative;top:6px;">
                                            </el-switch>
                                        </el-tooltip>

                                    </el-col>

                                    <el-col :span="3">
                                        <el-tooltip content="点击添加" placement="top" effect="light">
                                            <el-button circle icon="el-icon-plus" type="primary" size="medium"
                                                @click="submitCountDown()"></el-button>
                                        </el-tooltip>

                                    </el-col>

                                    <el-col :span="24" style="margin-top:2vh;margin-bottom:2vh;">
                                        <el-input v-model="countDownText" placeholder="在这里记录下吧！" size="medium"
                                            maxlength="30" show-word-limit></el-input>
                                    </el-col>

                                </el-row>
                                <el-row style="height:345px;overflow: scroll;">

                                    <el-col v-if="this.count_downs.length === 0">
                                        <el-empty description="还没有倒计时，快添加吧！" :image-size="200"></el-empty>
                                    </el-col>

                                    <el-col style="margin-top:10px;" :span="24" v-for="item in count_downs">
                                        <el-card shadow="hover" style="position:relative;">

                                            <el-tooltip content="点击关闭这个倒计时" placement="bottom" effect="light">
                                                <el-button circle size="mini" type="info" class="countDownBtn"
                                                    @click="closeCountDown(item)" style="z-index:3">
                                                </el-button>
                                            </el-tooltip>

                                            <el-row>
                                                <el-col :span="24" style="text-align:left;">
                                                    <span class="writtenByZxt" v-if="item.count_down_person === '张小兔'">
                                                        张小兔
                                                    </span>
                                                    <span class="writtenByYxy" v-if="item.count_down_person === '杨小鱼'">
                                                        杨小鱼
                                                    </span>
                                                    <span class="emergencyCountDownExtension"
                                                        v-if="item.count_down_emergency">
                                                        紧急！
                                                    </span>
                                                </el-col>
                                            </el-row>


                                            <el-row>
                                                <el-col :span="24" style="text-align:left;">
                                                    <span class="countDownText">
                                                        {{ item.count_down_content }}
                                                    </span>
                                                </el-col>
                                            </el-row>


                                            <el-row>
                                                <el-col :span="24" class="countingDown">
                                                    <span class="countingDownText">
                                                        {{ getCountDownTime(item.count_down_time) }}
                                                    </span>
                                                </el-col>
                                            </el-row>


                                            <el-row>
                                                <el-col :span="24" style="text-align:left;">
                                                    <span
                                                        :class="item.count_down_emergency ? 'countDownExtension emergencyCountDownExtension' : 'countDownExtension'">
                                                        结束时间 {{
                                                                $moment(item.count_down_time).format('YYYY-MM-DD HH:mm:ss')
                                                        }}
                                                    </span>
                                                </el-col>
                                            </el-row>
                                        </el-card>


                                    </el-col>
                                </el-row>
                            </el-card>
                        </el-col>
                        <el-col :span="14">
                            <el-card class="storyCard storyHidden line2">
                                <el-row>
                                    <el-col class="storyText">
                                        <span class="storyTitle">
                                            记录下今天
                                        </span>
                                    </el-col>
                                </el-row>
                                <el-divider content-position="left">
                                    <span class="writtenByZxt" v-if="this.$userInfo.$userName === '张小兔'">
                                        张小兔
                                    </span>
                                    <span class="writtenByYxy" v-if="this.$userInfo.$userName === '杨小鱼'">
                                        杨小鱼
                                    </span>
                                    <i class="el-icon-date storyDate"></i>
                                    <span class="storyDate">
                                        <span>
                                            {{ nowDate }}
                                        </span>
                                    </span>
                                </el-divider>
                                <el-row>
                                    <el-col :span="16" style="margin-bottom:2vh;">
                                        <el-input v-model="inputTitle" placeholder="今天发生了什么呢" size="default"
                                            maxlength="50" show-word-limit></el-input>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-tooltip content="点击发表" placement="top" effect="light">
                                            <el-button type="primary" size="default" @click="submitUpload"
                                                :disabled="submitPermission" icon="el-icon-chat-line-square" round>
                                                发表一下
                                            </el-button>
                                        </el-tooltip>

                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col>
                                        <el-input type="textarea" size="default" placeholder="记录一下吧！"
                                            v-model="inputText" maxlength="2000" show-word-limit
                                            :autosize="{ minRows: 7, maxRows: 7 }">
                                        </el-input>
                                    </el-col>
                                </el-row>


                                <el-row>
                                    <el-col style="height: 220px;margin-top:2vh;overflow:scroll;">
                                        <span v-if="this.tempFileList.length === 0"
                                            style="font-family:`HMOS_Regular`;color:#ccc">
                                            图片多的时候这里是可以滚动的喔
                                        </span>
                                        <el-upload action="https://api-proxy.yanghaocheng.workers.dev/upload/img" :headers="{
                                            apikey: 'FG8orFhD0x2DWt5T4qgoNhvtXTfX4V'
                                        }" :on-remove="onRemove" name="img" :on-success="onSuccess" :on-error="onError"
                                            :on-exceed="onExceed" :limit="5" list-type="picture-card"
                                            :before-upload="beforeUpload" :auto-upload="true"
                                            :on-preview="handlePictureCardPreview"
                                            style="margin-top:2vh;margin-bottom:2vh;" ref="upload"
                                            :disabled="this.$userInfo.$userLimit !== '1'">
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                        <el-dialog :visible.sync="dialogVisible">
                                            <img width="100%" :src="dialogImageUrl" alt="">
                                        </el-dialog>
                                    </el-col>
                                </el-row>


                            </el-card>
                        </el-col>
                    </el-row>
                </div>





                <el-card v-for="item in story" :key="item.post_id" class="storyCard storyHidden">

                    <el-tooltip content="点击关闭这个帖子" placement="bottom" effect="light">
                        <el-button circle size="mini" type="info" class="postBtn" @click="closePost(item)"
                            style="z-index:1" v-if="item.person === $userInfo.$userName">
                        </el-button>
                    </el-tooltip>

                    <el-row>
                        <el-col class="storyText">
                            <span class="storyTitle">
                                {{ item.post_title }}
                            </span>
                        </el-col>
                    </el-row>

                    <el-divider content-position="left">
                        <span class="writtenByZxt" v-if="item.person === '张小兔'">
                            张小兔
                        </span>
                        <span class="writtenByYxy" v-if="item.person === '杨小鱼'">
                            杨小鱼
                        </span>
                        <i class="el-icon-date storyDate"></i>
                        <span class="storyDate">
                            {{ item.post_date }}
                        </span>
                    </el-divider>

                    <el-row style="display:flex;margin-bottom:20px;">
                        <el-col :span="24" class="storyContent">
                            {{ item.post_content }}
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :span="6" class="storyPic" v-for="pic in item.pics" style="margin-bottom:10px;">
                            <el-image style="width: 11.5vw; height: 11.5vw;display:inline-block;" :src="pic" fit="cover"
                                :preview-src-list="item.pics"></el-image>
                        </el-col>
                    </el-row>

                    <el-divider content-position="left">
                        <i class="el-icon-chat-line-square storyDate"></i>
                        <span class="storyDate" v-if="item.discusses.length !== 0">
                            评论
                        </span>
                        <span class="storyDate" v-else>
                            还没有评论哦，快来评论吧！
                        </span>
                    </el-divider>

                    <div style="position:relative;margin-bottom:10px;" v-for="discuss in item.discusses">
                        <el-tooltip content="点击关闭这条评论" placement="bottom" effect="light">
                            <el-button circle size="mini" type="info" class="discussBtn"
                                @click="closeDiscuss(item, discuss)" style="z-index:1"
                                v-if="discuss.person === $userInfo.$userName">
                            </el-button>
                        </el-tooltip>
                        <el-row>
                            <el-col style="text-align:left;">
                                <span class="discussPerson">
                                    {{ discuss.person }}
                                </span>
                                <span class="discussDate">
                                    {{ $moment(discuss.discuss_date).format('YYYY-MM-DD HH:mm') }}
                                </span>
                            </el-col>
                            <el-col style="text-align:left">
                                <span class="discussContent">
                                    {{ discuss.discuss_content }}
                                </span>
                            </el-col>
                        </el-row>
                    </div>


                    <el-row style="margin-top:20px" :gutter="20">
                        <el-col :span="22">
                            <el-input type="text" placeholder="评论一下吧！" v-model="item.discuss" maxlength="200"
                                show-word-limit size="default">
                            </el-input>
                        </el-col>
                        <el-col :span="2">
                            <el-tooltip content="点击评论" placement="top" effect="light">
                                <el-button type="primary" size="default" @click="submitDiscuss(item)"
                                    icon="el-icon-chat-line-square" circle>
                                </el-button>
                            </el-tooltip>
                        </el-col>
                    </el-row>

                </el-card>


                <el-pagination class="storyHidden" style="margin-top:5vh;margin-bottom:15vh;" background
                    :page-size="pageSize" layout="prev, pager, next" :total="postTotalCount" @current-change="loadPage"
                    :current-page="postCurrentPage">
                </el-pagination>
            </el-col>
        </el-row>

    </div>
</template>

<script>
export default {
    name: 'ourSpace',
    created() {

    },
    data() {
        return {
            count_downs: [],
            photoWall: [
                "https://img.codesocean.top/image/1666807674352",
                "https://img.codesocean.top/image/1666807219777",
                "https://img.codesocean.top/image/1666807239892",
                "https://img.codesocean.top/image/1666807270272",
                "https://img.codesocean.top/image/1666807308291",
                "https://img.codesocean.top/image/1666807318608",
                'https://img.codesocean.top/image/1667049807924',
                'https://img.codesocean.top/image/1667049835090',
                'https://img.codesocean.top/image/1667049843094',
                'https://img.codesocean.top/image/1667049846960',
                'https://img.codesocean.top/image/1667049952485'
            ],
            loadingPageTag: false,
            countDownTime: '',
            countDownText: '',
            emergencyCountDown: false,
            submitPermission: false,
            tempFileList: [],
            UrlAndImgID: [],
            fileListLength: 0,
            inputText: '',
            inputTitle: '',
            files: [],
            nowDate: "",
            story: [],
            dialogImageUrl: '',
            dialogVisible: false,
            postTotalCount: 0,
            pageSize: 10,
            postCurrentPage: 1,
            littlePlan: '',
            plans: [],
            updateCountDownInterval: undefined
        }
    },
    beforeDestroy() {
        if (this.formatDate) {
            clearInterval(this.formatDate);
        }
        if (this.updateCountDownInterval) {
            clearInterval(this.updateCountDownInterval);
        }
    },
    mounted() {
        if (this.$userInfo.$userLimit === '') {
            this.$message({
                message: '不要乱来哦',
                type: 'warning'
            });
            this.$router.push('/noZone');
        } else if (this.$userInfo.$userLimit > '1') {
            this.$message({
                message: '不要乱来哦',
                type: 'warning'
            });
            this.$router.push('/home');
        }

        this.getTotal();
        this.currentTime();
        this.cancelLoading();
        this.loadPage(1)
        this.getPlan();
        this.getCountDown();

        this.updateCountDownInterval = setInterval(() => {
            this.$forceUpdate()
        }, 1000)

    },
    methods: {
        submitDiscuss(item) {

            let discussContent = item.discuss;
            if (discussContent === "") {
                this.$message({
                    message: '还没写东西呢',
                    type: 'warning'
                });
                return;
            }
            let itemId = item.post_id;
            item.discuss = '';
            let time = new Date().getTime().toString();
            let tempData = {
                discuss_id: time,
                discuss_content: discussContent,
                person: this.$userInfo.$userName,
                post_id: itemId
            }
            this.$axios({
                method: 'post',
                url: this.$baseUrl + '/posts/uploadDiscuss',
                data: tempData
            }).then((res) => {
                this.$message({
                    message: '评论成功',
                    type: 'success'
                });
                this.loadPage(this.postCurrentPage);
            }).catch((err) => {
                this.$message({
                    message: '评论时出了点小问题，重试一下',
                    type: 'error'
                });
            });
        },
        timemillis2str(time) {
            let day = Math.floor(time / (1000 * 60 * 60 * 24))
            let hours = Math.floor((time / (1000 * 60 * 60)) % 24)
            let minutes = Math.floor((time / (1000 * 60)) % 60)
            let seconds = Math.floor((time / 1000) % 60)
            if (seconds < 0) {
                return "已过去 " + Math.abs(day + 1) + '天 ' + Math.abs(hours + 1) + '时 ' + Math.abs(minutes + 1) + '分 ' + Math.abs(seconds) + '秒'
            } else {
                return "还剩下 " + day + '天 ' + hours + '时 ' + minutes + '分 ' + seconds + '秒'
            }
        },
        getCountDownTime(time) {
            return this.timemillis2str(this.$moment(time).format('x') - new Date().getTime())
        },
        submitCountDown() {

            if (this.$userInfo.$userLimit !== '1') {
                this.$message({
                    message: '没有权限操作',
                    type: 'warning'
                });
                return;
            }
            if (this.countDownTime === '') {
                this.$message({
                    message: '时间还没选呢',
                    type: 'warning'
                });
                return;
            } else if (this.countDownText === '') {
                this.$message({
                    message: '东西还没填呢',
                    type: 'warning'
                });
                return;
            } else {
                let tempCountDownTime = this.$moment(this.countDownTime).format('YYYY-MM-DD HH:mm:ss');
                let tempCountDownText = this.countDownText;
                let tempEmergencyCountDown = this.emergencyCountDown;
                let tempCountDownPerson = this.$userInfo.$userName;
                let countDownData = {
                    countDownTime: tempCountDownTime,
                    countDownText: tempCountDownText,
                    emergency: tempEmergencyCountDown,
                    countDownPerson: tempCountDownPerson
                };
                console.log(tempCountDownPerson)
                this.$axios({
                    method: 'post',
                    url: this.$baseUrl + '/countDowns/uploadCountDown',
                    data: countDownData
                }).then((res) => {
                    this.$message({
                        message: '添加倒计时成功',
                        type: 'success'
                    });
                    this.countDownTime = '';
                    this.countDownText = '';
                    this.emergencyCountDown = false;
                    this.getCountDown();
                }).catch((err) => {
                    this.$message({
                        message: '添加倒计时时出了点小问题，重试一下',
                        type: 'error'
                    });
                });
            }
        },
        getCountDown() {
            let that = this;
            this.$axios({
                method: 'get',
                url: that.$baseUrl + '/countDowns/getcountDownList'
            }).then((res) => {
                that.count_downs = [];
                for (let item of res.data.data) {
                    that.count_downs.push(item);
                }
                // console.log(that.count_downs);
            }).catch((err) => {
                that.$message({
                    message: '获取倒计时时出了点小问题，重试一下',
                    type: 'error'
                })
            })
        },
        closeCountDown(item) {
            if (this.$userInfo.$userLimit !== '1') {
                this.$message({
                    message: '没有权限操作',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('确定要关闭这个倒计时吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let tempCountDownId = item.count_down_id;
                let _this = this;
                console.log(tempCountDownId)
                this.$axios({
                    method: 'post',
                    url: this.$baseUrl + '/countDowns/closeCountDown',
                    data: {
                        countDownId: tempCountDownId
                    }
                }).then((response) => {
                    _this.$message({
                        message: '关闭成功',
                        type: 'success'
                    });
                    _this.getCountDown();
                }).catch((err) => {
                    this.$message({
                        message: '关闭倒计时时出了点小问题，重试一下',
                        type: 'error'
                    });
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消关闭'
                });
            });
        },
        closeDiscuss(item, discuss) {
            this.$confirm('确定要关闭这个评论吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let tempDiscussId = discuss.discuss_id
                let _this = this;
                this.$axios({
                    method: 'post',
                    url: this.$baseUrl + '/posts/closeDiscuss',
                    data: {
                        discussId: tempDiscussId
                    }
                }).then((response) => {
                    _this.loadPage(_this.postCurrentPage);
                    _this.$message({
                        message: '关闭成功',
                        type: 'success'
                    });
                }).catch((err) => {
                    _this.$message({
                        message: '关闭评论时出了点小问题，重试一下',
                        type: 'error'
                    });
                    _this.loadPage(_this.postCurrentPage);
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消关闭'
                });
            });
        },
        closePost(item) {
            if (this.$userInfo.$userLimit !== '1') {
                this.$message({
                    message: '没有权限操作',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('确定要关闭这个帖子吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let tempPostId = item.post_id;
                let _this = this;
                console.log(tempPostId)
                this.$axios({
                    method: 'post',
                    url: this.$baseUrl + '/posts/closePost',
                    data: {
                        postId: tempPostId
                    }
                }).then((response) => {
                    _this.loadPage(_this.postCurrentPage);
                    _this.$message({
                        message: '关闭成功',
                        type: 'success'
                    });
                }).catch((err) => {
                    this.$message({
                        message: '关闭帖子时出了点小问题，重试一下',
                        type: 'error'
                    });
                    this.loadPage(_this.postCurrentPage);
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消关闭'
                });
            });
        },
        getPlan() {
            let that = this;
            this.$axios({
                method: 'get',
                url: this.$baseUrl + '/plans/getPlanList'
            }).then((response) => {
                that.plans = [];
                // console.log(response.data.data)
                for (let item of response.data.data) {
                    that.plans.push(item);
                }
                console.log(that.plans);
            }).catch((err) => {
                that.$message({
                    message: '获得小计划时出了点小问题，重试一下',
                    type: 'error'
                });
            })
        },
        closePlan(item) {
            if (this.$userInfo.$userLimit !== '1') {
                this.$message({
                    message: '没有权限操作',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('确定要关闭这个小计划吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let tempPlanId = item.plan_id;
                this.$axios({
                    method: 'post',
                    url: this.$baseUrl + '/plans/closePlan',
                    data: {
                        planId: tempPlanId
                    }
                }).then((response) => {
                    this.$message({
                        message: '关闭成功',
                        type: 'success'
                    });
                    this.getPlan();
                }).catch((err) => {
                    console.log(err);
                    this.$message({
                        message: '关闭小计划时出了点小问题，重试一下',
                        type: 'error'
                    });
                    this.getPlan();
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消关闭'
                });
            });
        },
        toFinishingPlan(item) {
            let tempPlanId = item.plan_id;
            this.$axios({
                method: 'post',
                url: this.$baseUrl + '/plans/setPlanFinishingStatus',
                data: {
                    planId: tempPlanId,
                    status: "no"
                }
            }).then((response) => {
                this.getPlan();
            }).catch((err) => {
                this.$message({
                    message: '切换状态时出了点小问题，重试一下',
                    type: 'error'
                });
                this.getPlan();
            });
        },
        toFinishedPlan(item) {
            let tempPlanId = item.plan_id;
            this.$axios({
                method: 'post',
                url: this.$baseUrl + '/plans/setPlanFinishingStatus',
                data: {
                    planId: tempPlanId,
                    status: "finished"
                }
            }).then((response) => {
                this.getPlan();
            }).catch((err) => {
                this.$message({
                    message: '切换状态时出了点小问题，重试一下',
                    type: 'error'
                });
                this.getPlan();
            });
        },
        submitPlan() {
            if (this.$userInfo.$userLimit !== '1') {
                this.$message({
                    message: '没有权限操作',
                    type: 'warning'
                });
                return;
            }
            if (this.littlePlan === "") {
                this.$message({
                    message: '还没写捏',
                    type: 'warning'
                });
                return;
            }
            let tempContent = this.littlePlan;
            let littlePlanData = {
                person: this.$userInfo.$userName,
                content: tempContent
            };
            this.$axios({
                method: 'post',
                url: this.$baseUrl + '/plans/uploadPlan',
                data: littlePlanData
            }).then((response) => {
                this.$message({
                    message: '添加小计划成功',
                    type: 'success'
                });
                this.littlePlan = "";
                this.getPlan();
            }).catch((err) => {
                this.$message({
                    message: '添加小计划时出了点小问题，重试一下',
                    type: 'error'
                });
            });
        },
        refreshObserver() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('storyShow');
                    }
                });
            })
            const hiddenElements = document.querySelectorAll('.storyHidden');
            hiddenElements.forEach((el) => observer.observe(el));
        },
        onExceed(files, fileList) {
            // alert(fileList.length);
            this.$message({
                message: '最多只能上传5张照片',
                type: 'error'
            });
        },
        beforeUpload(file) {
            // alert(file.name);
            this.submitPermission = true;
            let fileType = file.name;
            fileType = fileType.substring(fileType.length - 4).toLowerCase();
            if (fileType !== '.jpg' && fileType !== '.png' && fileType !== '.gif' && fileType !== 'jpeg') {
                this.$message({
                    message: "文件格式有误，请上传jpg、png、gif、jpeg格式的图片",
                    type: 'error'
                });
                this.submitPermission = false;
                return false;
            }
            // alert(file.size);
            if (file.size > 10 * 1024 * 1024) {
                this.$message({
                    message: "文件大小不能超过10MB",
                    type: 'error'
                });
                this.submitPermission = false;
                return false;
            }
        },
        currentTime() {
            setInterval(this.formatDate, 500);
        },
        formatDate() {
            let date = new Date();
            let year = date.getFullYear(); // 年
            let month = date.getMonth() + 1; // 月
            let day = date.getDate(); // 日
            let hour = date.getHours(); // 时
            hour = hour < 10 ? "0" + hour : hour;
            let minute = date.getMinutes(); // 分
            minute = minute < 10 ? "0" + minute : minute;
            let second = date.getSeconds(); // 秒
            second = second < 10 ? "0" + second : second;
            this.nowDate = `${year}-${month}-${day} ${hour}:${minute}`;
        },
        cancelLoading() {
            setTimeout(() => {
                this.loading = false;
            }, 500);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        submitUpload() {
            if (this.$userInfo.$userLimit !== '1') {
                this.$message({
                    message: '没有权限操作',
                    type: 'warning'
                });
                return;
            }
            if (this.inputTitle === "" || this.inputText === "") {
                this.$message({
                    message: '有东西没写喔',
                    type: 'warning'
                });
                return;
            }
            let title = this.inputTitle;
            let text = this.inputText;
            let list = this.tempFileList;
            let post_data = {
                post_title: title,
                post_content: text,
                img_list: list,
                person: this.$userInfo.$userName
            };
            this.$axios({
                method: 'post',
                url: this.$baseUrl + '/posts/uploadPost',
                data: post_data
            }).then((response) => {
                this.$message({
                    message: '发表成功',
                    type: 'success'
                });
                this.loadPage(1);
                this.inputTitle = "";
                this.inputText = "";
                this.tempFileList = [];
                this.$refs.upload.clearFiles();
            }).catch((err) => {
                this.$message({
                    message: '发表说说时出现问题，重试一下',
                    type: 'error'
                })
                this.loadPage(1);
                console.log(err);
                this.inputTitle = title;
                this.inputText = text;
                this.tempFileList = list;
            })
        },
        onSuccess(response, file, fileList) {
            console.log(response);
            let temp = {
                file: file,
                url: response.url,
                img_id: response.img_id
            };
            this.tempFileList.push(temp);
            this.submitPermission = false;
            console.log("添加成功")
            console.log(this.tempFileList)
        },
        onError(err, file, fileList) {
            this.$message({
                message: '发生错误',
                type: 'error'
            })
        },
        getTotal() {
            let _this = this;
            this.$axios({
                method: 'get',
                url: this.$baseUrl + "/posts/getTotal",
            })
                .then(function (response) {
                    _this.postTotalCount = response.data.data[0].total;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadPage(page) {
            this.loadingPageTag = true;
            let _this = this;
            this.$axios({
                method: 'get',
                url: this.$baseUrl + "/posts/getPostList?page=" + page + "&pageSize=" + this.pageSize,
            }).then(function (response) {
                _this.story = [];
                for (let item of response.data.data) {
                    item.post_date = _this.$moment(item.post_date).format('YYYY-MM-DD HH:mm')
                    _this.story.push(item);
                }
                _this.$nextTick(() => {
                    _this.refreshObserver();
                })
                _this.postCurrentPage = page;
                _this.loadingPageTag = false;
            }).catch(function (error) {
                console.log(error);
                _this.loadingPageTag = false;
            });
        },
        onRemove(_file, fileList) {
            let imgId = ''
            for (let i = 0; i < this.tempFileList.length; i++) {
                if (this.tempFileList[i].file === _file) {
                    imgId = this.tempFileList[i].img_id;
                }
            }
            this.tempFileList = this.tempFileList.filter((item) => {
                return item.img_id != imgId;
            });
            this.$axios({
                method: "post",
                url: "http://img.codesocean.top/image/delete_img",
                headers: {
                    apikey: this.$store.state.apikey
                },
                data: {
                    img_id: imgId
                }
            })
            this.tempFileList.splice(this.tempFileList.indexOf(file), 1);
            // console.log("删除成功")
            // console.log(this.tempFileList)
        },

    }
}
</script>


<style scoped lang="scss">
.countingDown {
    text-align: left;
}

.countingDownText {
    display: inline-block;
    margin-top: 10px;
    font-family: "HMOS_Regular";
    font-weight: 600;
    font-size: 20px;
}

.countDownExtension {
    display: inline-block;
    position: relative;
    top: 4px;
    font-family: "HMOS_Regular";
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
}

.emergencyCountDownExtension {
    color: #ff6363;
    font-family: "HMOS_Regular";
    font-weight: 600;
}

.timerContainer {
    width: 100%;
    height: 460px;
    background: #bfa;
}

.line2 {
    height: 580px !important;
}

.countDownBtn {
    position: absolute;
    right: 20px;
    top: 20px;
}

.postBtn {
    position: absolute;
    right: 30px;
    top: 30px;
}

.discussBtn {
    position: absolute;
    right: 20px;
    top: 20px;
}

.countDownText {
    display: inline-block;
    margin-top: 10px;
    font-family: "HMOS_Regular";
    font-weight: 400;
}

.planText {
    display: inline-block;
    margin-top: 10px;
    font-family: "HMOS_Regular";
    font-weight: 400;
}

.planBtn {
    z-index: 2;
    position: absolute;
    right: 20px;
    top: 20px;
    width: 16px;
    height: 16px;
}

.planFinished {
    color: #6cc441;
}

.planFinishing {
    color: #e6a23c;
}

.planFinished:hover {
    color: #82c460;
    cursor: pointer;
}

.planFinishing {
    color: #e4ac57;
    cursor: pointer;
}

.planExtension {
    display: inline-block;
    position: relative;
    top: 4px;
    font-family: "HMOS_Regular";
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
}

.line1 {
    height: 350px;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}

.zxtMark {
    background-color: transparent;
    color: inherit;
    background-image: linear-gradient(#ff6363, #ff6363);
    background-repeat: no-repeat;
    background-size: 100% 30%;
    background-position: 0 100%;
}

.storyDate {
    font-family: "HMOS_Regular";
    font-weight: 600;
    font-size: 16px;
}

.storyContent {
    display: inline-block;
    text-indent: 30px;
    align-self: center;
    text-align: left;
}

.discussContent {
    display: inline-block;
    text-indent: 30px;
    align-self: center;
    text-align: left;
    margin-top: 10px;
}

.storyTitle {
    font-family: "HMOS_Regular";
    font-size: 30px;
    font-weight: 600;
}

.writtenByZxt {
    font-family: "HMOS_Regular";
    font-size: 20px;
    font-weight: 600;
    color: #ff6363;
}

.discussPerson {
    font-family: "HMOS_Regular";
    font-size: 18px;
    font-weight: 600;
}

.discussDate {
    font-family: "HMOS_Regular";
    font-size: 10px;
    font-weight: 600;
}

.writtenByYxy {
    font-family: "HMOS_Regular";
    font-size: 20px;
    color: #409eff;
    font-weight: 600;
}

.storyPic {
    height: auto;
    display: inline-block;
    align-self: center;
}

.storyText {
    height: 100%;
    text-align: left;
}

.storyCard {
    display: inline-block;
    margin: 0 auto;
    width: 100%;
    margin-top: 10px;
    height: auto;
    margin-bottom: 0px;
    text-align: center;
}

.ourSpaceBG {
    /* background-color:#bfa; */
    width: 100%;
    height: 100%;
    text-align: center;
    overflow: auto;
}

.storyBottom {
    text-align: center;
    color: #333;
    height: 100px;
    font-family: "HMOS_Regular"
}

.storyHidden {
    // filter: blur(5px);
    transform: translateY(50%);
    opacity: 0;
    transition: all 1000ms;
}

.storyShow {
    // filter: blur(0);
    transform: translateY(0);
    opacity: 1;
}

::-webkit-scrollbar {
    display: none;
}
</style>